import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import { Typography, TextField } from '@material-ui/core';

const styles = (theme) => ({
    section: {
        marginTop: theme.spacing(3),
    },
    subSection: {
        background: grey[100],
        padding: theme.spacing(3),
    },
    longField: {
        marginTop: 0,
        width: '100%',
    },
});

class MessageContent extends React.Component {
    handleChangeStep = (event) => {
        this.props.onChange(event.target.name, event.target.value);
    };

    render() {
        return (
            <React.Fragment>
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Step Text
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <TextField
                            fullWidth
                            name="text"
                            label="Text"
                            value={this.props.step.text}
                            margin="dense"
                            multiline
                            className={this.props.classes.longField}
                            onChange={this.handleChangeStep}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(MessageContent);
